import { LISTING_API_PREFIX } from 'src/common/constants';
import type { MinimalEditorListing } from 'src/common/types/api/listings';
import { apiRequest } from 'src/common/utils/apiFetch';
import captureException from 'src/common/utils/captureException';

type Results = MinimalEditorListing & {
  boat_id: string;
};

const mapKeys = (listings: Results[]): MinimalEditorListing[] => (
  listings.map(({
    id, boat_id, ...fields
  }) => ({
    id: id ?? boat_id,
    ...fields,
  }))
);

const filterPublishedListings = async (headline: string): Promise<MinimalEditorListing[]> => {
  const url = `${LISTING_API_PREFIX}published`;
  try {
    const response = await apiRequest(`${url}?headline=${headline}`, {
      method: 'GET',
    });
    if (response.ok) {
      return mapKeys((await response.json()).results);
    }
  } catch (err) {
    captureException(err);
  }
  return [];
};

export default filterPublishedListings;
